import { SubmittedKit, apiModelToSubmittedKit } from "./SubmittedKit";

export type SubmittedKitRun = {
    Id: number,
    SubmittedKitId: number,
    RunDate: Date,
    Measurement: number,
    PipetVolume: number,
    KitRunStatusId: number,
    Comments: String,
    SubmittedKit?: SubmittedKit
}

export function apiModelToSubmittedKitRun(apiModel: any) {
    return {
        Id: apiModel.id,
        SubmittedKitId: apiModel.submittedKitId,
        RunDate: new Date(apiModel.runDate),
        Measurement: apiModel.measurement,
        PipetVolume: apiModel.pipetVolume,
        KitRunStatusId: apiModel.kitRunStatusId,
        Comments: apiModel.comments,
        SubmittedKit: apiModelToSubmittedKit(apiModel.submittedKit)
    } as SubmittedKitRun;
}

export const blankSubmittedKitRun = {
    Id: 0,
    SubmittedKitId: 0,
    RunDate: new Date,
    Measurement: 0,
    PipetVolume: 0,
    KitRunStatusId: 1,
    Comments: "",
    SubmittedKit: undefined
} as SubmittedKitRun;
